<template>
  <div>
    <vs-table
      ref="courseTable"
      stripe
      class="vs-con-loading__container"
      single
      @selected="handleSelectedCourse"
      pagination
      :max-items="itemsPerPage"
      search
      :data="coursesAndModules"
      v-scroll-to="'#tasksTable'"
    >
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow">
        <div class="pl-3 pb-3 mr-4 flex items-center justify-between font-medium text-base">
          <h3>Courses & Modules</h3>
        </div>
        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
          <div
            class="p-4 border border-solid border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span
              class="mr-2"
            >{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ coursesAndModules.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : coursesAndModules.length }} of {{ coursesAndModules.length }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=25">
              <span>25</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=50">
              <span>50</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=100">
              <span>100</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="courseName">Course</vs-th>
        <vs-th sort-key="moduleName">Module</vs-th>
        <vs-th sort-key="moduleDescription">Description</vs-th>
        <vs-th sort-key="moduleProgress">Progress</vs-th>
        <vs-th sort-key="moduleProgress">Status</vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :data="item" :key="indextr" v-for="(item, indextr) in data">
          <vs-td :data="data[indextr].courseName">{{ item.courseName }}</vs-td>

          <vs-td :data="data[indextr].moduleName">{{ item.moduleName }}</vs-td>

          <vs-td :data="data[indextr].moduleDescription">{{ item.moduleDescription }}</vs-td>

          <vs-td>
            <div class="vx-row w-full " style="text-align: center">
              <vs-progress
                  :percent="Number(item.moduleProgress)"
                  :color="getProgressColor(Number(item.moduleProgress))"
                  :height="12"
                  class="shadow-md "
                />
              <small class="ml-2 "><span>{{item.moduleProgress.toFixed(2) + '%'}}</span></small>
            </div>
          </vs-td>
          <vs-td>
            <div v-if="item.studentModuleStatusId == 9 || item.studentModuleStatusId == 2">
              <div v-if="item.moduleProgress != 100" style="text-align: center;">
                
              </div>
              <div v-else-if="item.lastTaskCompleted"> 
                <vs-chip color="success">Completed</vs-chip>
              </div>
              <div v-else>
                <vs-chip color="success">{{ item.studentModuleStatus }}</vs-chip>
              </div>
            </div>
            <div v-else-if="item.studentModuleStatusId == 10">
              <vs-chip color="success">Assessed</vs-chip>
            </div>
            <div v-else-if="item.lastTaskCompleted">
              <vs-chip color="success">Completed</vs-chip>
            </div>
            <div v-else-if="item.studentModuleStatusId != 9 && item.studentModuleStatusId != null">
              <vs-chip color="success">{{ item.studentModuleStatus }}</vs-chip>
            </div>
            <div v-else>
              <vs-chip color="success">No Status</vs-chip>
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>

    <vs-divider v-show="showTasks" />
    <vs-table
      v-show="showTasks"
      id="tasksTable"
      ref="tasksTable"
      class="vs-con-loading__container"
      stripe
      single
      pagination
      max-items="10"
      search
      :data="tasks"
    >
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <div class="pl-3 pb-3 mr-4 flex items-center justify-between font-medium text-base">
          <h3 class="ml-2">Completed Tasks</h3>
        </div>
        <div class="p-3 mb-4 ml-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-success border border-solid border-success" @click="refreshTasks">
          <feather-icon icon="RefreshCcwIcon" svgClasses="h-4 w-4" />
          <span class="ml-2 text-base text-success">Refresh</span>
        </div>
      </div>
      <template slot="thead">
        <vs-th sort-key="taskName">Name</vs-th>
        <vs-th sort-key="taskType">Type</vs-th>
        <vs-th sort-key="completedDate">Date Completed</vs-th>
        <vs-th sort-key="statusName">Status</vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :data="task" :key="indextr" v-for="(task, indextr) in data">
          <vs-td :data="data[indextr].taskName">{{ task.taskName }}</vs-td>

          <vs-td :data="data[indextr].taskType">{{ task.taskType }}</vs-td>

          <vs-td
            :data="data[indextr].completedDate"
          >{{ task.completedDate.replace("T", " ").split('.')[0] }}</vs-td>

          <vs-td :data="data[indextr].statusName">
            <vs-chip v-show="statussesToShow.includes(task.statusId)" :color="getStatusColor(task.statusId)">{{setStatusName(task.statusName)}}</vs-chip>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <vs-divider class="mb-6 pt-0"></vs-divider>
    <div class="vx-row">
      <vs-spacer></vs-spacer>
      <div class="vx-col">
        <vs-button color="warning" type="border" class="mb-2" v-scroll-to="'#studentInfoCard'" @click="cancelAdd">Close</vs-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    studentId: {
      type: Number,
      required: true
    },
  },
  data() {
    return {
      itemsPerPage: 6,
      isMounted: false,
      loadingColor: "#fff",
      coursesAndModules: [],
      tasks: [],
      statussesToShow: [1, 2, 3, 4, 5, 6, 11,12,25],
      showTasks: false,
      moduleId: 0
    };
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.courseTable.currentx;
      }
      return 0;
    }
  },
  methods: {
    loadCourseInfo() {
      const self = this;
      self.showLoadingOnElement("courseTable", 1, "corners");

      var onSuccess = function(response) {
        self.coursesAndModules = response.data;
      };
      var onFinally = function() {
        self.$vs.loading.close(self.$refs.courseTable.$el);
        self.$refs.courseTable.searchx = "";
      };

      self.$ajaxGet(self, "Student/ListCourseInfo/" + self.studentId, onSuccess, onFinally);
    },
    handleSelectedCourse(courseModule) {
      var self = this;
      self.tasks = [];
      self.showTasks = true;
      self.moduleId = courseModule.moduleId;
      self.loadTasks();
    },
    cancelAdd() {
      this.$emit("cancelAdd")
    },
    loadTasks() {
      const self = this;
      self.showLoadingOnElement("tasksTable", 1, "corners");

      var onSuccess = function(response) {
        self.tasks = response.data;
      };
      var onFinally = function() {
        self.$vs.loading.close(self.$refs.tasksTable.$el);
        self.$refs.tasksTable.searchx = "";
      };

      self.$ajaxGet(
        self,
        "Student/ListStudentTasksAdmin?studentId=" + self.studentId + "&moduleId=" + self.moduleId,
        onSuccess,
        onFinally
      );
    },
    refreshTasks() {
      var self = this;
      self.showLoadingOnElement("tasksTable", 1, "corners");

      var onSuccess = function (response) {
        self.tasks = response.data;
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.tasksTable.$el);
      };

      self.$ajaxGet(
        self,
        "Student/ListStudentTasksAdmin?studentId=" + self.studentId + "&moduleId=" + self.moduleId,
        onSuccess,
        onFinally
      );
    },
    getProgressColor(num) {
      if (num > 99) return "success";
      if (num <= 99) return "warning";
    },
    getStatusColor(statusId) {
      var self = this;
      if(statusId == 1)
        return 'primary';
      else if(statusId == 2 || statusId == 3 || statusId == 6)
        return 'success';
      else if(statusId == 4 || statusId == 11 || statusId == 12)
        return 'warning';
      else if(statusId == 5)
        return 'danger';
      else if(statusId == 25)
        return 'primary';
      return 'primary';
    },
    openAlert(){
      this.$vs.dialog({
        color: 'warning',
        title: 'Information',
        text: 'Sorry, this task has not been assessed yet.',
        acceptText: 'OK'
      })
    },
    showLoadingOnElement(element, scale, type) {
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    },
    setStatusName(statusName) {
      if(statusName == 'Completed')
        return 'Waiting for Assessment';
      else if(statusName == 'Query')
        return 'Queried';
      else if(statusName == 'Moderated')
        return 'Moderated';
      else if(statusName == 'ReadyForStudentReview' || statusName == 'SurveyReadyForStudentReview'){
        return 'Waiting for Student'
      }
      else if(statusName == 'RemedialsPassedDue')
        return 'Remedials Passed Due';
      else
        return statusName;
    },
    scrollToNavbar() {
      var scrollOptions = {
        easing: "ease-in",
        offset: -500,
        force: true,
        cancelable: true,
        x: false,
        y: true
      };
      var cancelScroll = this.$scrollTo(
        document.getElementById("navbarGlobal"),
        500,
        scrollOptions
      );
    },
    scrollToFooter() {
      var scrollOptions = {
        easing: "ease-in",
        offset: -480,
        force: true,
        cancelable: true,
        x: false,
        y: true
      };
      var cancelScroll = this.$scrollTo(
        document.getElementById("footerGlobal"),
        100,
        scrollOptions
      );
    }
  },
  mounted() {
    var self = this;
    self.loadCourseInfo();
    self.isMounted = true;
  }
};
</script>

<style lang="scss">

</style>
